import { SystemResponse } from "../api/GetSystemsByIntegratorResponse";

export interface SystemItem {
    id: string;
    name: string;
    description: string;
    updatedDate: string;
    isModified?: boolean;
}

export const mapToSystemItem = (item: SystemResponse): SystemItem => {
    return {
        id: item.id,
        name: item.name,
        description: item.description,
        updatedDate: item.audit.updatedDate
    };
};
